import { format } from 'date-fns';

export const formatToSimpleDate = (
  jsDate: Date | undefined | null,
  dateFormat = 'dd.MM.yyyy',
): string => (jsDate instanceof Date ? format(new Date(jsDate), dateFormat) : '');
